import MobileDetect from 'vendor/mobile-detect'

export default class App {
  constructor(options) {

    this.options = $.extend({
      dropFullscreen : 768
    }, options)

    this.browserPrefix = null

    this.elements = {
      window : $(window),
      html   : $('html'),
      body   : $('body'),
      wrap   : $('#l-wrap')
    }

    this.supports = {
      geolocation: navigator.geolocation
    }

    this.MD = new MobileDetect(window.navigator.userAgent)

    this.helpers = {
      scrollTop: function() {
        $('html,body').animate({
          scrollTop: 0
        }, 300)
      },
      goto: function($element) {
        $('html,body').animate({
          scrollTop: $element.offset().top - 30
        }, 300)
      },
      getBrowserPrefix: function() {

        var styles = window.getComputedStyle(document.documentElement, ''),
            pre = (Array.prototype.slice
              .call(styles)
              .join('')
              .match(/-(moz|webkit|ms)-/) || (styles.OLink === '' && ['', 'o'])
            )[1],
            dom = ('WebKit|Moz|MS|O').match(new RegExp('(' + pre + ')', 'i'))[1];


          return {
            dom: dom,
            lowercase: pre,
            css: '-' + pre + '-',
            js: pre[0].toUpperCase() + pre.substr(1)
          };

      },

      videoFallback: function($el) {
        $el.after('<div class="b-story-header__image" style="background-image:url(' + $el.data('fallback') + ')"></div>')
        $el.remove()
      }
    }
  }
}



/** WEBPACK FOOTER **
 ** ./system/app.js
 **/